export default {
  en: {
    title: 'Cookie Policy',
    updated: 'September 11, 2026',
    sections: [
      {
        heading: '1. What Are Cookies',
        paragraphs: [
          'Cookies are small text files stored on your device. We also use similar technologies such as local storage for session and preference data.',
        ],
      },
      {
        heading: '2. Cookies We Use',
        paragraphs: [
          'Essential cookies: required for login sessions, security, and core functionality.',
          'Preference cookies: remember language, currency, and UI settings.',
          'Analytics cookies: help us understand usage patterns to improve the Service (if enabled).',
        ],
      },
      {
        heading: '3. Third-Party Cookies',
        paragraphs: [
          'When you use Google Sign-In, PayPal checkout, or embedded third-party content, those providers may set their own cookies under their policies.',
        ],
      },
      {
        heading: '4. Managing Cookies',
        paragraphs: [
          'You can control cookies through your browser settings. Disabling essential cookies may prevent you from logging in or using parts of the Service.',
        ],
      },
      {
        heading: '5. Contact',
        paragraphs: [
          'Questions about cookies: contact@codelabs.id',
        ],
      },
    ],
  },
  id: {
    title: 'Kebijakan Cookie',
    updated: '11 September 2026',
    sections: [
      {
        heading: '1. Apa Itu Cookie',
        paragraphs: [
          'Cookie adalah file teks kecil yang disimpan di perangkat Anda. Kami juga menggunakan teknologi serupa seperti local storage untuk sesi dan preferensi.',
        ],
      },
      {
        heading: '2. Cookie yang Kami Gunakan',
        paragraphs: [
          'Cookie esensial: diperlukan untuk sesi login, keamanan, dan fungsi inti.',
          'Cookie preferensi: mengingat bahasa, mata uang, dan pengaturan UI.',
          'Cookie analitik: membantu memahami pola penggunaan untuk meningkatkan Layanan (jika diaktifkan).',
        ],
      },
      {
        heading: '3. Cookie Pihak Ketiga',
        paragraphs: [
          'Saat Anda menggunakan Masuk Google, checkout PayPal, atau konten pihak ketiga tertanam, penyedia tersebut dapat menetapkan cookie mereka sendiri sesuai kebijakan mereka.',
        ],
      },
      {
        heading: '4. Mengelola Cookie',
        paragraphs: [
          'Anda dapat mengatur cookie melalui pengaturan browser. Menonaktifkan cookie esensial dapat mencegah Anda masuk atau menggunakan bagian Layanan.',
        ],
      },
      {
        heading: '5. Kontak',
        paragraphs: [
          'Pertanyaan tentang cookie: contact@codelabs.id',
        ],
      },
    ],
  },
}
